import { render, staticRenderFns } from "./user-evaluation.vue?vue&type=template&id=70be0a04&scoped=true&"
import script from "./user-evaluation.vue?vue&type=script&lang=js&"
export * from "./user-evaluation.vue?vue&type=script&lang=js&"
import style0 from "./user-evaluation.vue?vue&type=style&index=0&id=70be0a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be0a04",
  null
  
)

export default component.exports